import { asContactId } from "../entities/contact.js";
const DEMO_INTERVIEW_ID = "demo-interview";
const DEMO_CONTACT_ID = asContactId(
  "00000000-0000-4000-8000-000000000000"
);
const QUESTION_SUMMARY_MAX_INTERVIEW_COUNT = 25;
const QUESTION_SUMMARY_MIN_INTERVIEW_COUNT = 5;
const MAX_GIFT_CARD_BALANCE_INCREASE_USD = 2e3;
const MIN_GIFT_CARD_BALANCE_INCREASE_USD = 100;
const MAX_UPLOAD_FILE_SIZE_BYTES = 25 * 1024 * 1024;
const MAX_UPLOAD_FILE_SIZE_MB = MAX_UPLOAD_FILE_SIZE_BYTES / (1024 * 1024);
const MAX_ATTACHMENT_CONTENT_LENGTH = 3e5;
const COMPETITORS_KEYWORD_TRACKER_NAME = "Competitors";
export {
  COMPETITORS_KEYWORD_TRACKER_NAME,
  DEMO_CONTACT_ID,
  DEMO_INTERVIEW_ID,
  MAX_ATTACHMENT_CONTENT_LENGTH,
  MAX_GIFT_CARD_BALANCE_INCREASE_USD,
  MAX_UPLOAD_FILE_SIZE_BYTES,
  MAX_UPLOAD_FILE_SIZE_MB,
  MIN_GIFT_CARD_BALANCE_INCREASE_USD,
  QUESTION_SUMMARY_MAX_INTERVIEW_COUNT,
  QUESTION_SUMMARY_MIN_INTERVIEW_COUNT
};
//# sourceMappingURL=shared.js.map
